(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecpr-992-exhaust-hub"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecpr-992-hub')) {
    customElements.define('ecpr-992-hub', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.selector = this.querySelector('[data-hub-vehicle]');
        this.panels = Array.from(this.querySelectorAll('[data-hub-panel]'));
        this.status = this.querySelector('[data-hub-status]');
        if (!this.selector || !this.panels.length) return;
        this.querySelector('[data-hub-selector]').hidden = false;
        this.showFamily(false);
        this.selector.addEventListener('change', () => this.showFamily(true));
        this.addEventListener('play', (event) => {
          this.querySelectorAll('audio').forEach((audio) => {
            if (audio !== event.target) audio.pause();
          });
          this.querySelectorAll('[data-hub-video-frame]').forEach((frame) => frame.remove());
          this.querySelectorAll('[data-hub-video]').forEach((button) => { button.hidden = false; });
        }, true);
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-hub-action]');
          if (link) this.record(link.dataset.hubAction, { product_id: link.dataset.productId || '' });
        });
        this.querySelector('[data-hub-guide]')?.addEventListener('toggle', (event) => {
          if (event.target.open) this.record('guide_open');
        });
      }
      showFamily(announce) {
        this.querySelectorAll('audio').forEach((audio) => audio.pause());
        this.querySelectorAll('[data-hub-video-frame]').forEach((frame) => frame.remove());
        this.querySelectorAll('[data-hub-video]').forEach((button) => { button.hidden = false; });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.hubPanel !== this.selector.value; });
        if (announce) {
          this.status.textContent = this.selector.selectedOptions[0].textContent;
          this.record('vehicle_select');
        }
      }
      record(action, detail = {}) {
        this.dispatchEvent(new CustomEvent('ecpr:992-hub', {
          bubbles: true,
          detail: { action, vehicle: this.selector.value, collection_id: this.dataset.collectionId, ...detail }
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ecpr-992-exhaust-sound"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecpr-992-sound')) {
    customElements.define('ecpr-992-sound', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.hub = this.closest('ecpr-992-hub');
        this.status = this.querySelector('[data-sound-status]');
        this.audios = Array.from(this.querySelectorAll('audio'));
        this.querySelectorAll('[data-sound-control]').forEach((button) => {
          const audio = this.querySelector('audio[id="' + button.dataset.soundControl + '"]');
          if (!audio) return;
          button.hidden = false;
          audio.hidden = true;
          const update = () => {
            button.setAttribute('aria-pressed', String(!audio.paused));
            button.querySelector('[data-sound-action]').textContent = audio.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
            button.querySelector('.ecpr-992-sound__symbol').textContent = audio.paused ? '▶' : 'Ⅱ';
          };
          button.addEventListener('click', async () => {
            this.status.textContent = '';
            if (!audio.paused) { audio.pause(); return; }
            this.hub?.querySelectorAll('audio').forEach((other) => {
              if (other !== audio) { other.pause(); other.currentTime = 0; }
            });
            try {
              await audio.play();
              this.hub?.record('sound_play', { product_id: this.dataset.productId, recording: button.dataset.soundLabel });
            } catch {
              update();
              this.status.textContent = this.dataset.errorLabel;
              audio.hidden = false;
            }
          });
          audio.addEventListener('play', update);
          audio.addEventListener('pause', update);
          audio.addEventListener('ended', () => { audio.currentTime = 0; update(); });
          audio.addEventListener('timeupdate', () => {
            const progress = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.currentTime / audio.duration : 0;
            button.querySelector('[data-sound-progress]').style.transform = 'scaleX(' + progress + ')';
          });
        });
        this.querySelector('[data-sound-details]').addEventListener('toggle', (event) => {
          if (!event.target.open) {
            this.audios.forEach((audio) => audio.pause());
            this.querySelector('[data-hub-video-frame]')?.remove();
            const button = this.querySelector('[data-hub-video]');
            if (button) button.hidden = false;
          }
        });
        const videoButton = this.querySelector('[data-hub-video]');
        if (videoButton) {
          videoButton.hidden = false;
          videoButton.addEventListener('click', () => {
            this.hub?.querySelectorAll('audio').forEach((audio) => audio.pause());
            this.hub?.querySelectorAll('[data-hub-video-frame]').forEach((frame) => frame.remove());
            const frame = document.createElement('iframe');
            frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoButton.dataset.hubVideo) + '?autoplay=1&playsinline=1&rel=0';
            frame.title = this.querySelector('.ecpr-992-sound__note').textContent;
            frame.allow = 'autoplay; encrypted-media; picture-in-picture';
            frame.allowFullscreen = true;
            frame.dataset.hubVideoFrame = '';
            videoButton.after(frame);
            videoButton.hidden = true;
            this.hub?.record('video_play', { product_id: this.dataset.productId });
          });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
